export const inputLabelWidth = 82;
